(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.click-nav-container');
    const categoriesToggle = document.querySelector('.click-nav-categories-toggle');
    const closeBtn = document.querySelector('.click-nav-close-btn');
    const backBtn = document.querySelector('.click-nav-back-btn');
    const overlay = document.querySelector('.click-nav-overlay');
    const wrapper = document.querySelector('.click-nav-wrapper');

    let activeStack = [];

    function openMenu() {
      container.classList.add('menu-open');
      if (categoriesToggle) categoriesToggle.setAttribute('aria-expanded', 'true');
      document.querySelectorAll('[data-click-nav-opener]').forEach((opener) => opener.setAttribute('aria-expanded', 'true'));
    }

    function closeMenu() {
      container.classList.remove('menu-open');
      if (categoriesToggle) categoriesToggle.setAttribute('aria-expanded', 'false');
      document.querySelectorAll('[data-click-nav-opener]').forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
      
      if (wrapper) {
        wrapper.querySelectorAll('.click-nav-item.is-active').forEach((el) => {
          el.classList.remove('is-active');
          const trigger = el.querySelector('.click-nav-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      }
      activeStack = [];
      updateBackButton();
    }

    if (categoriesToggle) categoriesToggle.addEventListener('click', openMenu);
    document.querySelectorAll('[data-click-nav-opener]').forEach((opener) => opener.addEventListener('click', openMenu));
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    function updateBackButton() {
      if (backBtn) {
        backBtn.style.visibility = (activeStack.length > 0) ? 'visible' : 'hidden';
      }
    }

    function toggleSubmenu(trigger) {
      const parentLi = trigger.closest('.click-nav-item');
      if (!parentLi) return;

      const isOpen = parentLi.classList.contains('is-active');

      if (!isOpen) {
        parentLi.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        activeStack.push(parentLi);
        updateBackButton();
      } else {
        trigger.setAttribute('aria-expanded', 'false');
        parentLi.classList.remove('is-active');
        activeStack = activeStack.filter((item) => item !== parentLi);
        updateBackButton();
      }
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (activeStack.length > 0) {
          const lastActiveLi = activeStack.pop();
          lastActiveLi.classList.remove('is-active');
          const trigger = lastActiveLi.querySelector('.click-nav-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          updateBackButton();
        }
      });
    }

    if (wrapper) {
      wrapper.addEventListener('click', function (event) {
        // 1. Isolate and capture explicit trigger chevron button selections first
        const arrowBtn = event.target.closest('.click-nav-trigger');
        if (arrowBtn) {
          event.preventDefault();
          event.stopPropagation();
          toggleSubmenu(arrowBtn);
          return;
        }

        const itemFlex = event.target.closest('.click-nav-item-flex');
        if (itemFlex) {
          const link = itemFlex.querySelector('.click-nav-link');
          if (link) {
            const parentLi = itemFlex.parentElement;
            const isTopLevelCategory = parentLi && parentLi.parentElement && parentLi.parentElement.id === 'ClickNavLevel1';

            if (isTopLevelCategory) {
              event.preventDefault();
              event.stopPropagation();
              const targetTrigger = itemFlex.querySelector('.click-nav-trigger');
              if (targetTrigger) toggleSubmenu(targetTrigger);
            } else {
              if (event.target !== link) {
                event.preventDefault();
                window.location.href = link.href;
              }
            }
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
